import {
  noteAnalyticsNavigation,
  startAnalyticsForPage,
} from "@/lib/analytics/posthog-client";

/**
 * Starts cookieless PostHog capture before the app becomes interactive, on
 * the hosts and pages `src/lib/analytics/posthog-config.ts` allows. Pages
 * inside the signed-in apps start from their layout instead, and everywhere
 * else this is one hostname check and no download.
 */
startAnalyticsForPage();

export function onRouterTransitionStart(url: string) {
  noteAnalyticsNavigation(url);
}
